/* Recently viewed: localStorage 记录 + 拉卡渲染 */
(function () {
  if (window.__geekoRecentlyViewedBound) return;
  window.__geekoRecentlyViewedBound = true;

  var STORAGE_IDS = 'geeko_recently_viewed';
  var STORAGE_HANDLES = 'geeko_recently_viewed_handles';
  var MAX_ITEMS = 20;
  var CONCURRENCY = 4;
  var GRAPHQL_URL = '/api/2025-10/graphql.json';
  var SECTION_SELECTOR = '[data-geeko-recently-viewed]';

  var abortController = typeof AbortController === 'function' ? new AbortController() : null;
  var fetchSignal = abortController ? abortController.signal : undefined;

  function onPageHide() {
    if (abortController) abortController.abort();
  }
  window.addEventListener('pagehide', onPageHide);

  function readJson(key, fallback) {
    try {
      var raw = window.localStorage.getItem(key);
      if (!raw) return fallback;
      var parsed = JSON.parse(raw);
      return parsed == null ? fallback : parsed;
    } catch (e) {
      return fallback;
    }
  }

  function writeJson(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (e) {
      return false;
    }
  }

  function getIds() {
    var ids = readJson(STORAGE_IDS, []);
    if (!Array.isArray(ids)) return [];
    var cleaned = [];
    var seen = {};
    for (var i = 0; i < ids.length; i++) {
      var id = String(ids[i] || '').trim();
      if (!id || seen[id]) continue;
      seen[id] = true;
      cleaned.push(id);
    }
    return cleaned.slice(0, MAX_ITEMS);
  }

  function getHandles() {
    var map = readJson(STORAGE_HANDLES, {});
    if (!map || typeof map !== 'object' || Array.isArray(map)) return {};
    return map;
  }

  function persist(ids, handles) {
    var nextIds = ids.slice(0, MAX_ITEMS);
    var nextHandles = {};
    for (var i = 0; i < nextIds.length; i++) {
      var id = nextIds[i];
      if (handles[id]) nextHandles[id] = handles[id];
    }
    writeJson(STORAGE_IDS, nextIds);
    writeJson(STORAGE_HANDLES, nextHandles);
  }

  function removeId(id) {
    var target = String(id);
    persist(
      getIds().filter(function (item) {
        return item !== target;
      }),
      getHandles()
    );
  }

  function recordCurrent() {
    var current = window.geekoRecentlyViewedCurrent;
    if (!current || current.id == null || current.id === '') return;

    var id = String(current.id);
    var handle = current.handle ? String(current.handle) : '';
    var ids = getIds().filter(function (item) {
      return item !== id;
    });
    ids.unshift(id);

    var handles = getHandles();
    if (handle) handles[id] = handle;
    persist(ids, handles);
  }

  function fetchGraphqlProduct(productId) {
    var query =
      'query { product(id: "gid://shopify/Product/' +
      productId +
      '") { handle status } }';
    return fetch(GRAPHQL_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query }),
      signal: fetchSignal,
    })
      .then(function (response) {
        if (!response.ok) return { handle: '', status: '' };
        return response.json();
      })
      .then(function (data) {
        var product = data && data.data && data.data.product;
        if (!product) return { handle: '', status: '' };
        return {
          handle: product.handle || '',
          status: product.status || '',
        };
      })
      .catch(function () {
        return { handle: '', status: '' };
      });
  }

  function isOffShelfStatus(status) {
    var value = String(status || '').toUpperCase();
    return value === 'ARCHIVED' || value === 'DRAFT' || value === 'UNLISTED';
  }

  function fetchStorefrontJson(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      signal: fetchSignal,
    }).then(function (response) {
      return { status: response.status };
    });
  }

  function fetchCardHtml(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=ajax-card-product', {
      signal: fetchSignal,
    }).then(function (response) {
      if (response.status === 404) return { status: 404, html: '' };
      if (!response.ok) return { status: response.status, html: '' };
      return response.text().then(function (html) {
        return { status: 200, html: html };
      });
    });
  }

  function parseProductInfo(html) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('product-info');
  }

  function isPlaceholderCard(node) {
    if (!node) return true;
    if (!node.getAttribute('data-product-id')) return true;
    return Boolean(node.querySelector('.dummy_card, .placeholder-svg'));
  }

  function loadCard(productId, handles) {
    return fetchGraphqlProduct(productId)
      .then(function (meta) {
        if (isOffShelfStatus(meta.status)) {
          return { id: productId, remove: true, node: null };
        }

        var handle = meta.handle || handles[productId] || '';
        if (!handle) return { id: productId, remove: true, node: null };

        return fetchStorefrontJson(handle).then(function (storefront) {
          if (storefront.status === 404) {
            return { id: productId, remove: true, node: null };
          }
          if (storefront.status !== 200) {
            return { id: productId, remove: false, node: null };
          }

          return fetchCardHtml(handle).then(function (result) {
            if (result.status === 404) return { id: productId, remove: true, node: null };
            if (result.status !== 200) return { id: productId, remove: false, node: null };

            var node = parseProductInfo(result.html);
            if (isPlaceholderCard(node)) return { id: productId, remove: true, node: null };

            handles[productId] = handle;
            return { id: productId, remove: false, node: node };
          });
        });
      })
      .catch(function () {
        return { id: productId, remove: false, node: null };
      });
  }

  function mapPool(items, limit, iterator) {
    var results = new Array(items.length);
    var cursor = 0;

    function worker() {
      if (cursor >= items.length) return Promise.resolve();
      var index = cursor++;
      return Promise.resolve(iterator(items[index], index)).then(function (value) {
        results[index] = value;
        return worker();
      });
    }

    var workers = [];
    var count = Math.min(limit, items.length);
    for (var i = 0; i < count; i++) workers.push(worker());
    return Promise.all(workers).then(function () {
      return results;
    });
  }

  function createSlide(sectionId, index, productInfo, slideClass) {
    var li = document.createElement('li');
    li.className = slideClass || 'grid__item slider__slide';
    li.id = 'Slide-' + sectionId + '-' + (index + 1);
    li.setAttribute('data-geeko-recently-viewed-index', String(index + 1));
    li.appendChild(document.importNode(productInfo, true));
    return li;
  }

  function refreshSlider(root) {
    var slider = root.querySelector('slider-component');
    if (slider && typeof slider.resetPages === 'function') {
      slider.resetPages();
    } else {
      window.dispatchEvent(new Event('resize'));
    }
  }

  function hideRoot(root) {
    root.setAttribute('hidden', '');
    root.classList.add('geeko-recently-viewed--empty');
  }

  function showRoot(root) {
    root.removeAttribute('hidden');
    root.classList.remove('geeko-recently-viewed--empty');
  }

  function isDesignMode(root) {
    return root.getAttribute('data-design-mode') === 'true';
  }

  function canPublish() {
    return (
      typeof Shopify !== 'undefined' &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    );
  }

  function getDisplayedProductIds(root) {
    var ids = [];
    var cards = root.querySelectorAll('product-info[data-product-id]');
    for (var i = 0; i < cards.length; i++) {
      var id = String(cards[i].getAttribute('data-product-id') || '').trim();
      if (id) ids.push(id);
    }
    return ids;
  }

  var VIEW_DWELL_MS = 1000;
  var VIEW_PX_TOLERANCE = 2;
  var viewTimers = new WeakMap();
  var viewTracked = new WeakSet();
  var viewObserver = null;

  function isRectFullyVisible(rect) {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var t = VIEW_PX_TOLERANCE;
    if (rect.width <= 0 || rect.height <= 0) return false;
    if (
      rect.top >= -t &&
      rect.left >= -t &&
      rect.bottom <= vh + t &&
      rect.right <= vw + t
    ) {
      return true;
    }
    return rect.height >= vh - t && rect.top <= t && rect.bottom >= vh - t;
  }

  function isBlockFullyVisible(entry) {
    if (entry.intersectionRatio >= 0.99) return true;
    return isRectFullyVisible(entry.boundingClientRect);
  }

  function publishImpression(root) {
    if (!canPublish() || viewTracked.has(root)) return;
    viewTracked.add(root);
    var productIds = getDisplayedProductIds(root);
    Shopify.analytics.publish('geeko_recently_viewed_impression', {
      product_ids: productIds,
      product_count: productIds.length,
      page: window.location.pathname + window.location.search,
      timestamp: Date.now(),
    });
  }

  function clearViewTimer(root) {
    var pending = viewTimers.get(root);
    if (pending) {
      clearTimeout(pending);
      viewTimers.delete(root);
    }
  }

  function startViewTimer(root) {
    if (viewTimers.has(root) || viewTracked.has(root)) return;
    var timer = setTimeout(function () {
      viewTimers.delete(root);
      if (!isRectFullyVisible(root.getBoundingClientRect())) return;
      publishImpression(root);
      if (viewObserver) viewObserver.unobserve(root);
    }, VIEW_DWELL_MS);
    viewTimers.set(root, timer);
  }

  function getViewObserver() {
    if (viewObserver || typeof IntersectionObserver !== 'function') return viewObserver;
    viewObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var root = entry.target;
          if (viewTracked.has(root)) return;
          if (isBlockFullyVisible(entry)) {
            startViewTimer(root);
          } else {
            clearViewTimer(root);
          }
        });
      },
      { threshold: [0, 0.1, 0.25, 0.5, 0.75, 0.9, 0.99, 1] }
    );
    return viewObserver;
  }

  function observeImpression(root) {
    var observer = getViewObserver();
    if (!observer || viewTracked.has(root)) return;
    observer.observe(root);
  }

  function getCardVariantId(card) {
    var input = card.querySelector('input.product-variant-id, input[name="id"], [name="id"]');
    return input && input.value ? String(input.value) : '';
  }

  function publishProductClick(root, event) {
    if (!canPublish()) return;
    if (event.target.closest('.wl-btn, .wl-coll-btn, [data-wishlist], [data-gridwllist], [data-wl-pdp-icon-manual]')) {
      return;
    }

    var link = event.target.closest('a[href*="/products/"]');
    if (!link || !root.contains(link)) return;

    var href = link.getAttribute('href') || '';
    if (!href || href === '#' || href.indexOf('javascript:') === 0) return;

    var card = link.closest('product-info');
    if (!card) return;

    var productId = card.getAttribute('data-product-id') || '';
    if (!productId) return;

    var slide = card.closest('[data-geeko-recently-viewed-index]');
    var position = slide ? Number(slide.getAttribute('data-geeko-recently-viewed-index')) : 0;

    Shopify.analytics.publish('geeko_recently_viewed_product_click', {
      product_id: Number(productId),
      variant_id: Number(getCardVariantId(card) || 0),
      position: position,
      href: href,
      page: window.location.pathname + window.location.search,
      timestamp: Date.now(),
    });
  }

  function renderRoot(root) {
    var list = root.querySelector('[data-geeko-recently-viewed-list]');
    if (!list) return Promise.resolve();

    var excludeId = String(root.getAttribute('data-exclude-id') || '').trim();
    var ids = getIds().filter(function (id) {
      return id !== excludeId;
    });

    if (!ids.length) {
      if (!isDesignMode(root)) hideRoot(root);
      return Promise.resolve();
    }

    var handles = getHandles();
    var sectionId = root.getAttribute('data-section-id') || 'recently-viewed';
    var enableSlider = root.getAttribute('data-enable-slider') !== 'false';
    var slideClass = enableSlider ? 'grid__item slider__slide' : 'grid__item';

    return mapPool(ids, CONCURRENCY, function (id) {
      return loadCard(id, handles);
    }).then(function (results) {
      var staleIds = [];
      var slides = [];

      for (var i = 0; i < results.length; i++) {
        var item = results[i];
        if (!item) continue;
        if (item.remove) staleIds.push(item.id);
        if (item.node) slides.push(item.node);
      }

      if (staleIds.length) {
        persist(
          getIds().filter(function (id) {
            return staleIds.indexOf(id) === -1;
          }),
          handles
        );
      } else {
        persist(getIds(), handles);
      }

      if (!slides.length) {
        if (!isDesignMode(root)) hideRoot(root);
        return;
      }

      list.innerHTML = '';
      for (var j = 0; j < slides.length; j++) {
        list.appendChild(createSlide(sectionId, j, slides[j], slideClass));
      }

      showRoot(root);
      requestAnimationFrame(function () {
        refreshSlider(root);
        observeImpression(root);
      });
    });
  }

  function clearAll() {
    persist([], {});
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (root) {
      var list = root.querySelector('[data-geeko-recently-viewed-list]');
      if (list) list.innerHTML = '';
      if (!isDesignMode(root)) hideRoot(root);
    });
  }

  function onClick(event) {
    var clearBtn = event.target.closest('[data-geeko-recently-viewed-clear]');
    if (clearBtn) {
      event.preventDefault();
      clearAll();
      return;
    }

    var root = event.target.closest(SECTION_SELECTOR);
    if (!root) return;
    publishProductClick(root, event);
  }

  recordCurrent();
  document.addEventListener('click', onClick);

  var roots = document.querySelectorAll(SECTION_SELECTOR);
  if (!roots.length) return;

  var renders = [];
  roots.forEach(function (root) {
    renders.push(renderRoot(root));
  });
  Promise.all(renders).catch(function () {});
})();
